import { AuthorizationModel, AuthorizationByStatusModel } from './models/authorization-model';
import { AuthRoles, AuthUserType } from '../auth/auth.types';
import { AppConstants } from './app.constants';

export class AppPermissions {

  public static readonly canViewPBIReports: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* Results Persmissions */

  public static readonly canCreateResult: AuthorizationByStatusModel = <AuthorizationByStatusModel>{
    role: ['NESS Administrator'],
    userType: [],
    entityState: AppConstants.Result_FormMode_Add,
    roleUserType: [
      {
        roles: ['Application Administrator', 'Power User', 'Editor'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Application Administrator', 'Editor'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canViewResults: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canViewResultsByStatus: AuthorizationByStatusModel = <AuthorizationByStatusModel>{
    role: ['NESS Administrator'],
    userType: [],
    entityState: AppConstants.Result_FormMode_Add,
    roleUserType: [
      {
        roles: ['Power User', 'Application Administrator', 'Editor', 'Viewer'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Application Administrator', 'Power User', 'Editor', 'Viewer'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Application Administrator', 'Editor', 'Viewer'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* LE Partner Permissions */

  public static readonly canEditLEPartner: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  /* Event Permissions */

  public static readonly canCreateEvent: AuthRoles[] = ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'];

  public static readonly canEditEvent: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Application Administrator', 'Power User', 'Editor', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Application Administrator', 'Power User', 'Editor', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static readonly canViewEventFilters: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* People Permissions */

  public static readonly canEditPerson: AuthRoles[] = ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'];

  public static readonly canDeletePerson: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Editor', 'Application Administrator', 'NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canCreatePeople: AuthRoles[] = ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'];

  public static readonly canViewPeopleFilters: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* IR Permissions */

  public static readonly canCreateIRs: AuthorizationByStatusModel = <AuthorizationByStatusModel>{
    canCreate: true,
    authOrgCode: null,
    creatorId: null,
    assigneeIds: [],
    role: ['NESS Administrator'],
    userType: [],
    entityState: AppConstants.IR_FormMode_Add,
    roleUserType: [
      {
        roles: ['NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Application Administrator', 'Power User', 'Editor', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canEditIRs: AuthorizationByStatusModel = <AuthorizationByStatusModel>{
    canCreate: false,
    authOrgCode: null,
    creatorId: null,
    assigneeIds: [],
    role: ['NESS Administrator'],
    userType: [],
    entityState: AppConstants.IR_FormMode_Edit,
    roleUserType: [
      {
        roles: ['Application Administrator', 'Power User', 'Editor'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Application Administrator', 'Editor'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canViewIRs: AuthorizationByStatusModel = <AuthorizationByStatusModel>{
    canCreate: false,
    authOrgCode: null,
    creatorId: null,
    assigneeIds: [],
    role: ['NESS Administrator'],
    userType: [],
    entityState: AppConstants.IR_FormMode_View,
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* Location Permissions */

  public static readonly canViewLocationFilters: AuthorizationModel = {
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  } as AuthorizationModel;

  public static readonly canDeleteLocation: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Application Administrator', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Application Administrator', 'NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static readonly canEditLocation: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* Crime Gun Permissions */

  public static canViewCrimeGunsList: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static canViewCrimeGunDetails: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static canViewCrimeGun: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Viewer','Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Viewer','Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator', 'Editor', 'Application Administrator', 'Viewer'], userType: 'StateLocalLE' }
    ]
  };

  public static canAddTraceData: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static canViewTraceData: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Viewer','Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Viewer','Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static canEditCrimeGun: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Application Administrator', 'Editor', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static canEditCrimeGunFirearm: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Application Administrator', 'Editor', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };


  public static canViewTriagePDF: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator', 'Viewer', 'Editor', 'Application Administrator'], userType: 'StateLocalLE' }
    ]
  };

  public static canViewStepout: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Editor', 'Application Administrator', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  };

  /* User Preferences Permissions */
  public static canViewUserPreferences = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  /* Permissions to see linked agencies filter */
  public static canViewLinkedAgencies: AuthUserType[] = ['StateLocalLE'];

  public static canViewGeoFilterRegion: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  };

  public static canCreateCrimeGunsCaseAlerts: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Viewer', 'Editor', 'Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      }
    ]
  };

  public static canViewSLFilter: AuthorizationModel = <AuthorizationModel>{
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Application Administrator', 'Editor', 'Viewer'], userType: 'StateLocalLE' }
    ]
  };
}
